import { useState, useEffect } from "react";

import { srcPath } from "../util/Path";
import { audioErr } from "../util/Util";

export const useImgLoaded = (totalImg: number = 0): [boolean, () => void] => {
  const [loaded, setLoaded] = useState(0);

  const addImgLoaded = () => {
    if (loaded < totalImg) {
      setLoaded((prev) => prev + 1);
    }
  };

  return [loaded >= totalImg, addImgLoaded];
  // return [true, addImgLoaded];
};

export const useAudio = (src: string) => {
  const [audio, setAudio] = useState(new Audio(srcPath(src)));

  const playAudio = () => {
    audio.play().catch(() => audioErr(src));
  };

  useEffect(() => {
    setAudio(new Audio(srcPath(src)));
  }, [src]);

  return playAudio;
};
